// i18n area 'networks' — locale hu-HU (task #171, onda 4): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/networks.hu-HU.meta.json.
import type { enUS } from './networks'

export const huHU: typeof enUS = {
  networks: {
    common: {
      name: 'Név',
      scope: 'Scope',
      operState: 'Állapot',
      actions: 'Műveletek',
      create: 'Létrehozás',
      close: 'Bezárás',
      cancel: 'Mégse',
      delete: 'Törlés',
      edit: 'Szerkesztés',
      save: 'Mentés',
      editError: 'A szerkesztés nem sikerült',
      search: 'Keresés név szerint',
      empty: 'Itt még nincs semmi',
      saveError: 'Nem sikerült menteni',
      loadError: 'Nem sikerült betölteni — elérhető a TVirt backend?',
      createError: 'A létrehozás nem sikerült',
      deleteError: 'A törlés nem sikerült',
      deleteConfirmTitle: 'Törlöd: {name}?',
      deleteConfirmBody: 'A művelet nem visszafordítható.',
      nameHint: 'Kisbetűk, számjegyek és kötőjelek (DNS-1123)',
      up: 'Aktív',
      down: 'Inaktív',
      unknown: 'Ismeretlen',
      usedByVMs: 'VM',
      emptyTable: 'Nincs bejegyzés — adj hozzá egyet a + gombbal'
    },
    dialogTabs: {
      general: 'Általános',
      base: 'Alapdefiníció',
      advanced: 'Haladó konfiguráció',
      reserved: 'A TVirt számára fenntartott címtartományok',
      position: 'Pozíció',
      network: 'Hálózati konfiguráció',
      hosts: 'Résztvevő csomópontok'
    },
    reservedRanges: {
      note: 'Ezek a TVirt számára fenntartott IP-címtartományok, amelyekből automatikusan címet oszthat VM-eknek, konténereknek stb. MEGJEGYZÉS: az e tartományokba eső IP-ket a TVirt-ön kívül külső szolgáltatások/eszközök nem használhatják.',
      from: 'Ettől',
      to: 'Eddig'
    },
    overlay: {
      title: 'Overlay-hálózatok',
      createTitle: 'Overlay-hálózat létrehozása',
      editTitle: 'Overlay-hálózat szerkesztése',
      vni: 'VNI',
      vniHint: 'VXLAN Network Identifier — üresen hagyva automatikusan kiosztva',
      subnet: 'Alhálózat',
      subnetHint: 'Az overlay CIDR-je — az IPAM automatikusan származtatja belőle a nyilvántartási bejegyzést',
      mtu: 'MTU',
      weight: 'Súly',
      ceilMbps: 'Felső korlát (Mbps)',
      fairnessHint: 'A súly csak versengés esetén számít: szabad kapcsolaton minden hálózat a teljes sávszélességet használhatja. A felső korlát viszont mindig érvényes.',
      contention: 'Versengés',
      contentionTip: 'Legalább egy csomópont eldobásokat vagy overlimiteket lát sorbanállással EGYÜTT e hálózat osztályán: az uplink sávszélessége vitatott, a súlyok hatnak. Hogy mennyi és mióta, a csomópont net.shaping.* sorozataiban áll.',
      firewallPolicy: 'Tűzfalszabályzat',
      hosts: 'Hostok',
      hostsTitle: 'Résztvevő csomópontok',
      hostsHint: 'Minden csomópont deklarálja a saját underlay-végpontját — egy választó a csomópont VALÓS címeiből, a hálózati konfigurációjából kiolvasva; az opcionális overlay-címnek az alhálózaton belül kell lennie. A részvétel az elhelyezés megkötése.',
      hostNode: 'Csomópont',
      hostUnderlay: 'Underlay-IP',
      hostUnderlayPickNode: 'Előbb válaszd ki a csomópontot',
      hostAddress: 'Cím az overlayen (opcionális)',
      hostAddressOutside: 'Az overlay alhálózatán kívül ({cidr})',
      addHost: 'Csomópont hozzáadása',

      // Round #156 (dialog standard): le righe osservate del dialog dettagli.
      observedAt: 'Megfigyelve',
      attachedNics: 'Csatlakoztatott NIC-ek'
    },
    services: {
      title: 'Hálózati szolgáltatások',
      createTitle: 'Hálózati szolgáltatás létrehozása',
      editTitle: 'Hálózati szolgáltatás szerkesztése',
      kind: 'Típus',
      kindCategory: 'Szolgáltatások',
      selectKindHint: 'Válaszd ki a szolgáltatás típusát — az alatta lévő démon implementációs részlet, amelyet a TVirt kezel helyetted.',
      kindLabel: {
        dhcp: 'DHCP-szerver',
        ntp: 'NTP-szerver',
        vpn: 'VPN-szerver',
        dns: 'DNS-szerver',
        gateway: 'Gateway',
        'lb-rp': 'Load balancer és reverse proxy',
        floatip: 'Lebegő IP'
      },
      kindDesc: {
        dhcp: 'Címeket oszt a kiszolgált alhálózatokon — a címkészletek az alhálózatból, a gateway-ből és a TVirt számára fenntartott címtartományokból származnak.',
        dns: 'Autoritatív DNS a deklarált zónákon — a rekordok az IPAM-ból származnak, plusz a kézieid.',
        gateway: 'A csomópont gateway-ként szolgál egy hálózatnak — NAT (DNAT, 1:1, SNAT/masquerade) plusz statikus útválasztás a csatlakoztatott hálózatok között, dizájnból öngyógyító.',
        'lb-rp': 'Terheléselosztó / fordított proxy a szolgáltatásaid előtt — L4 vagy L7 figyelők tagokból álló poolok vagy egy Pod kész példányai fölött, menet közben átkonfigurálva.',
        ntp: 'A hálózatok idő-szolgáltatása — külső upstream szerverek relay-e, vagy a csomópont órája kiszolgálva a klienseknek.',
        vpn: 'VPN-koncentrátor a csomóponton — WireGuard vagy OpenVPN, te választasz: távoli hozzáférés az úton lévő klienseknek, vagy site to site alagút két hálózat között.',
        floatip: 'Egy cím, amely egyszerre csak egyetlen egészséges App-példányon vagy Podon ül, és annak kiesésekor a következő egészséges célra vándorol — failover démonok nélkül; az elosztás a terheléselosztónál marad.'
      },

      // Round Pod nativi P4: l'IP flottante (4b) e il backend Pod dell'lb-rp (4a).
      floatip: {
        hint: 'A lebegő IP a választott hálózaton él TOVÁBBI címként a birtokos példány saját névterében: nincsenek portok, nincs elosztás, nincs NAT — a kliens IP-je valódi marad.',
        address: 'Lebegő IP',
        targets: 'Célok',
        targetsHint: 'PREFERENCIA sorrendben: az első egészséges cél tartja a címet. Egy Pod az összes példányát jelenti, replikánként; minden célnak saját egészségkritériuma van. Minden célnak ugyanahhoz a hálózathoz kell csatlakoznia.',
        targetKind: 'Cél',
        targetApp: 'App-példány',
        targetPod: 'Pod (minden példány)',
        targetRef: 'Melyik',
        health: 'Egészség',
        healthRunning: 'Fut (minden konténer kész)',
        healthTcp: 'TCP kapcsolat',
        healthHttp: 'HTTP GET',
        healthPing: 'Ping',
        port: 'Port',
        path: 'Útvonal',
        addTarget: 'Cél hozzáadása',
        moveUp: 'Fel',
        moveDown: 'Le',
        preempt: 'Preempt',
        preemptHint: 'Ki (alapértelmezett): az egészséges birtokos megtartja a címet akkor is, ha egy magasabb cél visszatér — nincs ide-oda váltás. Be: mindig az első egészséges cél tartja.',
        holder: 'Birtokos',
        noHolder: 'nincs egészséges cél',
        since: 'ekkortól',
        verdicts: 'Megfigyelt célok',
        healthy: 'egészséges',
        unhealthy: 'nem egészséges',
        noVerdict: 'Még nincs döntés — az autoritás csomópont a következő menetében írja az első ítéletet.',
        vipChip: 'VIP {address}',
        vipChipTooltip: 'Ez a példány tartja a(z) {service} szolgáltatás {address} lebegő IP-jét'
      },
      poolSource: 'Végpontok',
      poolSourceMembers: 'Statikus tagok',
      poolSourcePod: 'Egy Pod kész példányai',
      poolBackendPod: 'Pod',
      poolBackendPort: 'Port',
      poolBackendHint: 'A végpontok követik a Podot: egy példány belép, amikor minden konténere készen fut, és azonnal kilép, amikor leskálázzák vagy meghal. Az aktív ellenőrzés alapból be van kapcsolva.',
      poolBackendCount: 'a(z) {pod} Pod kész példányai a(z) {port} porton',
      node: 'Csomópont',
      enabled: 'Engedélyezve',
      parked: 'Parkolva',
      subnets: 'Alhálózatok',
      subnetsHint: 'Az e példány által kiszolgált IPAM-alhálózatok — a címkészletek a CIDR-ből, a gateway-ből és a TVirt számára fenntartott címtartományokból származnak',
      noSubnets: 'Nincs IPAM-alhálózat — deklarálj előbb egy logikai fabric-hálózatot (vagy egy overlay-alhálózatot): az IPAM belőlük származik',
      iface: 'Figyelő interfész',
      ifaceHint: 'A host-interfész, amelyen a szolgáltatás megnyitja a socketjét (pl. egy bridge) — kötelező: egy hálózati szolgáltatás önálló, a „minden interfész” már nem létezik',
      dns: 'DNS-szerverek',
      domain: 'Tartomány',
      detail: 'Kiszolgál',
      subnetCount: '{n} alhálózat',
      zones: 'Zónák',
      zonesHint: 'Csak autoritatív — a démon sosem rekurzál. Az A rekordok a hivatkozott IPAM-alhálózatokban lévő csomópontok deklarált címeiből származnak; a reverse kapcsoló a megfelelő in-addr.arpa zónákat is kiszolgálja (PTR). Egy zónát a flottában legfeljebb egy DNS-példány szolgál ki. Az opcionális névszerver az az FQDN, amely a default ns.<zóna> helyett kerül az NS/SOA rekordokba; ha a zónán belülre esik, az A rekordja akkor is a kiszolgáló csomópontból származik.',
      zoneName: 'Zóna neve',
      zoneNs: 'Névszerver (NS)',
      zoneSubnets: 'IPAM-alhálózatok',
      zoneReverse: 'Reverse (PTR)',
      zoneRecords: 'Kézi rekordok',
      zoneRecordsHint: 'Soronként egy: név TÍPUS érték — A, CNAME, MX, TXT típusok. Név-ütközésnél a kézi rekord győz a származtatott felett.',
      addZone: 'Zóna hozzáadása',

      // lb-rp (wave 3 fondamenta): listener su pool inline — engine-less,
      // riconfigurato in volo.
      lbListeningHint: 'A példány EGY figyelőhálózatot és EGY címet deklarál — minden listener a saját portján köti le; egy második cím egy második szolgáltatás.',
      listeners: 'Listenerek',
      listenersHint: 'Minden listener a példány címét köti le a saját portján L4 (TCP-passthrough — a bájtok sosem nyílnak fel) vagy L7 (HTTP) módban, és az alábbi készletek egyikéhez továbbít. Egy cím/port párost csomópontonként legfeljebb egy példány szolgál ki. A módosítások menet közben érvényesülnek — se újraindítás, se elvesző kapcsolat.',
      listenerName: 'Név',
      listenerMode: 'Mód',
      modeL7: 'L7 — HTTP reverse proxy',
      modeL4: 'L4 — TCP-passthrough',
      listenerPort: 'Port',
      listenerPool: 'Készlet',
      addListener: 'Listener hozzáadása',
      pools: 'Készletek',
      poolsHint: 'A backendek, ahová a forgalom érkezik: statikus tagok round-robin vagy legkevésbé terhelt elosztással, opcionális aktív health checkkel, amely kiveszi a rotációból a beteg tagokat.',
      poolName: 'Név',
      poolAlgorithm: 'Algoritmus',
      algoRoundRobin: 'Round robin',
      algoLeastRequest: 'Legkevésbé terhelt',
      poolCheck: 'Health check',
      checkNone: 'Nincs',
      checkTcp: 'TCP-kapcsolat',
      checkHttp: 'HTTP',
      poolCheckPath: 'Szonda útvonala',
      poolInterval: 'Időköz (s)',
      poolMembers: 'Tagok',
      poolMembersHint: 'Soronként egy: cím:port, opcionálisan egy súllyal (1-128) — pl. 10.0.0.21:8080 2',
      addPool: 'Készlet hozzáadása',
      memberCount: '{n} tag',

      // ntp (round ntp — ratifica 2026-08-03, l'ultimo kind della famiglia):
      // il modo in parole parlate, la lista upstream solo dove significa
      // qualcosa, l'attacco di rete riusa le etichette del gateway.
      // #239 (netsvc autocontenuti): l'editor condiviso della lista di
      // listener dei kind dns e ntp — le due eccezioni multi-rete ratificate.
      listen: {
        assignment: 'Kiosztás',
        assignmentStatic: 'Statikus cím',
        assignmentAuto: 'Automatikus (TVirt fenntartott tartományok)',
        autoHint: 'A TVirt a logikai hálózat fenntartott tartományaiból húzza a címet és sticky-ként tartja — sosem húzza újra szerkesztésnél vagy failovernél.',
        title: 'Listenerek',
        hint: 'Egy hálózati szolgáltatás önálló: minden listener deklarálja a saját hálózatát (overlay, logikai fabric-hálózat vagy interfész) és egy címet a hálózat alhálózatán belül — címenként egy listener, a wildcard már nem létezik. A DNS és az NTP több hálózaton és azok több címén is figyelhet.',
        address: 'Figyelési cím',
        add: 'Listener hozzáadása'
      },
      ntp: {
        mode: 'Szinkronizációs mód',
        modeRelay: 'Külső szerverek relay-e',
        modeNodeClock: 'A csomópont órája',
        modeHint: 'A relay a deklarált upstream szerverektől vett időt szolgálja ki; a csomópont órája a kiszolgáló csomópont idejét adja — amelyet a klaszter amúgy is szinkronban tart',
        servers: 'Upstream szerverek',
        serversHint: 'Vesszővel elválasztva — hostnév vagy IP-cím; a szolgáltatás innen veszi az időt, és ezt szolgálja ki a hálózatnak',
        port: 'Figyelési port',
        listening: 'Figyel itt:'
      },

      vpn: {
        engine: 'Motor',
        engineHint: 'Te választod, és többé nem változik: a WireGuard modern, gyors és kernelbeli; az OpenVPN a kompatibilitás veteránja (TCP, ellenséges hálózatok)',
        engineLocked: 'A motor nem módosítható — egy másik motor új szolgáltatást jelent, a kulcsok és tanúsítványok nem vihetők át',
        mode: 'Mód',
        modeRemote: 'Távoli hozzáférés',
        modeSite: 'Site to site',
        modeHint: 'A távoli hozzáférés címet ad az úton lévő klienseknek az alagútban; a site to site két hálózatot köt össze',
        port: 'Figyelési port',
        protocol: 'Átvitel',
        protocolWireguardHint: 'A WireGuard csak UDP-t beszél',
        tunnelSubnet: 'Az alagút alhálózata',
        tunnelSubnetHint: 'A hálózat, amelyben a kliensek élnek — az IPAM-nyilvántartásba bejegyezve, ezzel a szolgáltatással születik és hal meg',
        dnsServers: 'A klienseknek küldött DNS',
        routes: 'A klienseknek küldött útvonalak',
        routesHint: 'Vesszővel elválasztott hálózatok, amelyek az alagútban érhetők el; az alagút alhálózata mindig benne van',
        peers: 'Peerek',
        peersHint: 'Hagyd üresen a nyilvános kulcsot, és a TVirt legenerálja a kulcspárt — majd a profillal együtt átadja. Illessz be egy kulcsot, és a peer megtartja a sajátját.',
        clients: 'Kliensek',
        clientsHint: 'Minden kliens e szolgáltatás CA-ja által kibocsátott tanúsítványt kap. Egy kliens eltávolítása VISSZAVONJA azt: a CRL azonnal újragenerálódik.',
        peerName: 'Név',
        publicKey: 'Nyilvános kulcs',
        publicKeyMinted: 'A TVirt generálja',
        peerAddress: 'Cím az alagútban',
        peerAddressHint: 'Üresen = kiosztva',
        allowedIps: 'Távoli alhálózatok',
        allowedIpsHint: 'Vesszővel elválasztva, ezen a peeren keresztül útvonalazva',
        endpoint: 'Végpont',
        presharedKey: 'Előre megosztott kulcs',
        keepalive: 'Keepalive (s)',
        addPeer: 'Peer hozzáadása',
        addClient: 'Kliens hozzáadása',
        auth: 'Hitelesítés',
        authTls: 'Tanúsítványok (TLS)',
        remote: 'Távoli végpont',
        remoteHint: 'A távoli vég host:port címe — üresen ez az oldal várakozik',
        peerRoutes: 'Távoli alhálózatok',
        serverPublicKey: 'Ennek a szervernek a nyilvános kulcsa',
        ca: 'Hitelesítésszolgáltató',
        listening: 'Figyel itt:',
        tunnel: 'Alagút',
        peerCount: '{n} peer',
        download: 'Profil letöltése',
        downloadError: 'A profilt nem sikerült exportálni',
        lastHandshake: 'Utolsó handshake',
        never: 'soha',
        traffic: '↓ {rx} · ↑ {tx}',
        connected: 'Kapcsolódva',
        idle: 'Tétlen'
      },

      // Gateway (wave 3 — nato nat, ratifica 2026-08-01/02; rinominato ed
      // esteso il 2026-08-03): le tre famiglie di regole NAT più le rotte
      // statiche su una rete di listening. Ogni forma ratificata è supportata.
      gateway: {
        attach: 'A figyelőhálózat típusa',
        attachOverlay: 'Overlay-hálózat',
        attachNetwork: 'Logikai fabric-hálózat',
        attachInterface: 'Nyers interfész',
        overlay: 'Overlay-hálózat',
        network: 'Logikai hálózat',
        interface: 'Interfész neve',
        interfaceHint: 'Egy host-interfész, amelyet a TVirt nem kezel — a címét készpénznek vesszük',
        address: 'Figyelési cím (gateway)',
        addressHint: 'A gateway-cím, amelyre a kliensek mutatnak — a figyelőhálózat alhálózatán belül',
        dnatTitle: 'DNAT-szabályok',
        dnatHint: 'Cél-NAT: az illeszkedő forgalom új címre (és opcionálisan új portra) irányítódik át. A lista bármely protokollja — a portok ott, ahol a protokoll hordozza őket.',
        snatTitle: 'SNAT-szabályok',
        snatHint: 'Forrás-NAT: az illeszkedő forgalom átírt forrással lép ki — egy explicit új cím (és opcionálisan új port), vagy üresen hagyva masquerade a kimeneti címen.',
        oneToOneTitle: '1:1 NAT-szabályok',
        oneToOneHint: 'Minden, a külső címre érkező csomag a belsőre képződik le, és a belső host a külsőként lép ki — minden protokoll, mindkét irány.',
        external: 'Külső cím',
        internal: 'Belső cím',
        addOneToOne: '1:1 szabály hozzáadása',
        family: 'Család',
        protocol: 'Protokoll',
        source: 'Forrás (cím/alhálózat)',
        destination: 'Cél (cím/alhálózat)',
        invert: 'NOT',
        srcPorts: 'Forrásportok',
        dstPorts: 'Célportok',
        dstPortsHint: 'Port vagy porttartomány (80, 8000-8099)',
        toAddress: 'Új cím',
        toPort: 'Új port',
        snatTo: 'Új forrás (üresen = masquerade)',
        snatToHint: 'Explicit forráscím; üresen = masquerade a kimeneti címen',
        addDnat: 'DNAT-szabály hozzáadása',
        addSnat: 'SNAT-szabály hozzáadása',
        routesTitle: 'Statikus útvonalak',
        routesHint: 'A csomópont a csatlakoztatott hálózatai között útválaszt (az IP forwarding aktív); ezek az útvonalak ezen túli elérhetőséget adnak — tiszta kernel, a dinamikus útválasztás egy későbbi körrel érkezik.',
        routeDestination: 'Cél-alhálózat',
        routeGateway: 'Next hop',
        routeMetric: 'Metrika',
        addRoute: 'Útvonal hozzáadása',
        listening: 'Figyel itt:',
        rules: '{d} DNAT · {o} 1:1 · {s} SNAT · {r} útvonal'
      },
      unknownSince: 'Ismeretlen — utolsó jelentés {m} perce',
      lastWord: 'Utolsó szó',

      // Round #156 (dialog standard): le righe osservate e il riepilogo in
      // sola lettura del blocco kind nel dialog dettagli.
      reportObservedAt: 'Utolsó jelentés',
      lastErrorRow: 'Utolsó hiba',
      recordsCount: '{n} kézi rekord',
      phase: {
        configured: 'Konfigurálva',
        running: 'Fut',
        error: 'Hiba'
      },
      authorityNode: 'Authority (hozzárendelés)',
      preferredNode: 'Preferált csomópont',
      preferredNodeHint: 'Puha preferencia, sosem kényszer: a következő elhelyezési döntésnél a példány itt landol, ha ez a tag jogosult — önmagában semmit sem mozgat; a lépés az „Authority áthelyezése”.',
      noPreference: 'Nincs preferencia (automatikus elhelyezés)',
      moving: 'Mozgásban',
      movingTooltip: 'Itt észlelve, míg az authority a(z) {node} csomópontot jelöli ki: a lépés konvergál.',
      placement: {
        title: 'Elhelyezés',
        loading: 'Felmérés folyamatban…',
        loadError: 'Az elhelyezési felmérés nem válaszolt — próbáld újra később.',
        draftHint: 'A felmérés a deklarált hálózati csatolásból számolódik: a szolgáltatás létrejöttekor jelenik meg. A rendszer elutasítja a létrehozást, ha egyetlen tag sem tudja kiszolgálni, és az elutasítás megnevezi azt a mechanizmust, amely kiürítette a halmazt.',
        eligibleCount: '{m} tagból {n} tudja kiszolgálni ezt a példányt',
        recommended: 'Ajánlott',
        eligible: 'Jogosult',
        notEligible: 'Nem jogosult',
        blockedReachability: 'a hálózat nem ér el ehhez a taghoz',
        blockedRequireTag: 'megkövetelt címke blokkolja (requireNodes)',
        blockedExcluded: 'a szimuláció kizárta',
        preferenceUnknown: 'nem (vagy már nem) tagja a klaszternek',
        preferenceIgnored: 'A(z) „{node}” preferencia ma nem jogosult: {reason}. A felmérés ajánlása érvényesül — sosem hiba, a szolgáltatás máshol él.',
        emptyReachability: 'Egyetlen tag sem tudja kiszolgálni ezt a példányt: a hálózat sehová sem ér el — semmilyen címkeigazítás nem segít. Kábelezd be a csomópontot, vagy vidd a szolgáltatást oda, ahol van hálózat.',
        emptyRequireTag: 'Egyetlen tag sem tudja kiszolgálni ezt a példányt: a megkövetelt címkék ürítették ki a halmazt — vedd ki a bejegyzést a requireNodes-ból, vagy címkézz fel egy tagot.',
        spof: 'Egyetlen meghibásodási pont',
        spofDetail: 'A példányt pontosan egy tag tudja befogadni: hiba esetén a failovernek nincs hová mennie. Egy több listeneres szolgáltatás EGYSÉGKÉNT költözik — a jelöltnek látnia kell az ÖSSZES hálózatát: ez az ára.',
        whatIf: 'Tagok kiesésének szimulálása',
        whatIfHint: 'A kiürítés what-if-je: kérdezz az evakuáció ELŐTT, ne a failovernél derüljön ki.',
        survives: 'Ha {nodes} kiesik, a szolgáltatásnak még mindig van otthona.',
        notSurvives: '{nodes} evakuálása után ez a szolgáltatás ÁLL: a származtatott kényszer győz a rendelkezésre állással szemben (R30) — egy démon, amely ott él, ahová a hálózat nem ér el, senkit sem szolgál ki és senkit sem riaszt.',
        transfer: 'Authority áthelyezése',
        transferError: 'Az áthelyezés nem sikerült',
        transferTarget: 'Céltag',
        transferHint: 'Csak a jogosult tagokat ajánlja fel — preferencia az érvényes halmazon belül, sosem override. Nincs feladat: a workerök következő menete MAGA a lépés (a régi csomópont learat, az új felépít).'
      }
    },
    fabric: {
      tabDerivation: 'Derikáció',
      importNetwork: 'Importálás másik fabricból',
      importTitle: 'Logikai hálózat importálása',
      importHint: 'Az importálás a kifejezett csatlakozás: a hálózat a tulajdonosé marad (ugyanaz az identitás, ugyanaz a stem, ugyanaz a tvf-<stem> bridge), és innen erre a fabricra portokra/LAGG-okra képezed le — leképezni AZT jelenti, hogy állítod: a kézbesítés ugyanabba az L2-tartományba fut ki, mint a tulajdonosé.',
      importPick: 'A tulajdonos hálózata',
      importNone: 'Nincs mit importálni: a többi fabricnak nincs olyan saját hálózata, amelyet ez a fabric ne ismerne már',
      importedNetworksTitle: 'Importált hálózatok',
      noImported: 'Nincs importált hálózat',
      importedFrom: 'importálva innen: {fabric}',
      importedBy: 'Importálta: {list}',
      importedCount: '+{n} importált',
      owner: 'Tulajdonos',
      bridge: 'Bridge',
      bond: 'Bond',
      unimport: 'Import eltávolítása',
      unimportConfirm: 'Eltávolítod a(z) {name} hálózat (tulajdonos: {fabric}) importját ebből a fabricból? Elutasítva, amíg e fabric egy portja vagy LAGG-ja leképezi, vagy egy vendég, App vagy szolgáltatás csak ezen a lábon keresztül kap kiszolgálást.',
      unimportRefused: 'Az import még használatban — {detail}',
      deriv: {
        codeHint: {
          deviceHeldByFabric: 'Ez a node azt a hálózatot már egy másik fabricból kapja, amelynek tagja: egy node a megosztott hálózatot csak EGYETLEN lábán át veszi (ugyanazon L2 két uplinkje egy STP nélküli bridge-ben hurok). Vedd le a leképezést a két fabric egyikének portjairól vagy LAGG-járól.',
          otherFabricDerived: 'A dokumentum egy olyan fabric blokkját hordozza, amely felé a node már nem deklarál kábelt: előbb alkalmazd annak a fabricnak a tervét (az eszközei eltávolítását javasolja), vagy vedd át őket take-ownershippel, ha a fabric már nem létezik.'
        },
        hint: 'Az O.3 derivációs terv: minden kábelezett node-hoz az állapot, a származtatott-vs-jelenlegi diff, a DEKLARÁLT bond-topológia, a dual-stack flipek és a strukturált elutasítások/figyelmeztetések. Csak olvasható az EXPLICIT apply-ig — semmi sem landol soha magától egy node-on.',
        refresh: 'Terv újratöltése',
        empty: 'Egyetlen node sincs ehhez a fabrichoz kábelezve (és egyik sem hordozza már a blokkját).',
        refusal: 'Elutasítás',
        warning: 'Figyelmeztetés',
        generation: 'dokumentumgeneráció {n}',
        state: {
          manual: 'Kézi',
          derived: 'Származtatott',
          diverged: 'Eltért'
        },
        topologyTitle: 'Deklarált topológia',
        members: 'tagok',
        primary: 'elsődleges',
        held: 'EGY tagon tartva',
        form: {
          perNetworkBond: 'Bond hálózatonként',
          singleBond: 'Egyetlen tartalék bond',
          laggBond: 'LACP bond (LAGG)',
          singlePort: 'Egyetlen port'
        },
        colAction: 'Művelet',
        colKind: 'Fajta',
        colDevice: 'Device',
        colDetail: 'Részlet',
        action: {
          add: 'hozzáad',
          remove: 'eltávolít',
          replace: 'lecserél'
        },
        diffEmpty: 'Nincs függő diff — az alkalmazott dokumentum egyezik a renderrel.',
        diffBlocked: 'Nincs diff: a fenti elutasítások blokkolják ezt a node-ot.',
        phasePlanned: 'tervezett (1/3. lépés)',
        phaseDraining: 'ürül (2/3. lépés)',
        probeUnobserved: 'Ürítési szonda: sosem jelentett — az üresség ISMERETLEN (egy retire most elutasításra kerülne).',
        probeFailed: 'Ürítési szonda: a megfigyelés MEGHIÚSULT — az ismert időbélyegek továbbvivődnek, sosem egy «üres», amit senki sem mért.',
        probeActive: {
          one: 'Szonda: {n} kiépített kapcsolat még a régi címen',
          other: 'Szonda: {n} kiépített kapcsolat még a régi címen'
        },
        probeLastActive: 'utolsó aktivitás {time}',
        probeEmpty: {
          one: 'Szonda: üres {n} perce',
          other: 'Szonda: üres {n} perce'
        },
        probeEmptyUnknown: 'Szonda: üres (mióta, ismeretlen).',
        impact: '{nics} vNIC és {apps} App ezen a node-on használja ezeket a hálózatokat: {list}',
        apply: 'Alkalmazás erre a node-ra',
        applyTitle: 'Deriváció alkalmazása — {node}',
        applyIntro: 'A származtatott konfiguráció újraírja {node} hálózati dokumentumát ({n} változás) ugyanazon az ajtón át, mint a host-network szerkesztő — NetworkManager checkpoint és becsületes szonda beleértve. A terv alábbi figyelmeztetései az aktussal utaznak: olvassa el őket megerősítés előtt.',
        applyError: 'Az apply meghiúsult',
        applyRefused: 'A node elutasította:',
        planMoved: 'A fabric megváltozott ez után az előnézet után — SEMMI sem lett alkalmazva. A terv újratöltődött: nézze meg újra és próbálja újra.',
        retire: 'Kivonás',
        retireTitle: 'Visszafordíthatatlansági pont — {address} kivonása',
        restore: 'Visszaállítás',
        restoreTip: 'Vissza az apply előtti pillanatképhez ({previous}. generáció) — egylépéses visszavonás (H13)',
        restoreTitle: 'Előző dokumentum visszaállítása — {node}',
        restoreIntro: 'A(z) {node} hálózati dokumentuma visszaáll az utolsó apply előtt készült pillanatképre ({previous}. generáció), {next}. generációként újraírva a(z) {current}. helyett. A worker ugyanúgy konvergálja, mint bármely más dokumentumot.',
        restoreRedo: 'A lecserélt dokumentum lesz az új pillanatkép: az újbóli visszaállítás a redo.',
        restoreClosesChain: 'A pillanatkép a származtatás előtti kézi dokumentum: a lánc itt lezárul — nincs több visszavonás, a csomópont kézi marad a következő apply-ig.',
        restoreConfirm: 'Visszaállítás',
        restoreError: 'A visszaállítás nem sikerült',
        retireIntro: 'Ez véglegesen eltávolítja a(z) {address} címet ({network}) a {point} pontról. Ez után az aktus után a visszaút a FORDÍTOTT flip — a régi cím újradeklarálása ugyanazon a motoron át — sosem vak helyreállítás.',
        retireOld: 'Régi cím (eltávolítva)',
        retireNew: 'Új cím (marad)',
        retireEmptyFact: 'Az ürítési szonda üresnek jelenti a címet: ez az eltávolítás nem szakít meg megfigyelt kapcsolatot.',
        retireConfirm: 'Cím kivonása',
        severActiveLoss: {
          one: '{n} kiépített kapcsolat megszakítása még a régi címen — ezzel az aktussal meghal',
          other: '{n} kiépített kapcsolat megszakítása még a régi címen — ezzel az aktussal meghalnak'
        },
        severUnknownLoss: 'Az ISMERETLEN elfogadása: a szonda sosem figyelte meg ezt a címet (vagy a megfigyelés meghiúsul) — élő kapcsolatok szakadhatnak meg.'
      },
      title: 'Fabric',
      createTitle: 'Fabric létrehozása',
      networks: 'Hálózatok',
      switches: 'Switchek',
      ports: 'Portok',
      laggs: 'LAGG-ok',
      subnets: 'Alhálózatok',
      tabOverview: 'Áttekintés',
      tabNetworks: 'Logikai hálózatok',
      tabSwitches: 'Switchek',
      overviewHint: 'A fabric egy pillantásra: minden logikai hálózat az MTU-jával és az alhálózatával (a VLAN-ok csak a portonkénti/LAGG-onkénti leképezésekben élnek — ugyanaz a hálózat különböző portokon különböző tagekkel utazhat). A fabric egy KÜLSŐ infrastruktúra nyilvántartása — a TVirt megfigyel és deklarál, sosem provisionál, és csak az irányítása alá regisztrált NIC-ekhez nyúl.',
      absorptionHint: 'Minden itt deklarált alhálózat ugyanabban az írásban SZÁRMAZTATJA a bejegyzését az IPAM-nyilvántartásban — a hálózattal él és hal.',
      scopeFixedHint: 'A scope rögzített: a klaszter gyökere — a fizikai infrastruktúra definíció szerint klaszterszintű.',
      networksHint: 'Minden hálózat kötelező MTU-t (default 1500) és kötelező alhálózatot visel; az itt deklarált gateway, DNS-szerverek és statikus útvonalak az EGYETLEN FORRÁS a szerverek NIC-jei, az Appok és a hálózati szolgáltatások számára.',
      switchesHint: 'A kézi nyilvántartás: egy port nem használt, leképezett (untagged és VLAN-tagenkénti forgalom a logikai hálózatokra) vagy egy LAGG tagja — a tagport nem visel saját leképezéseket.',
      mtu: 'MTU',
      cidr: 'CIDR',
      cidrHint: 'Kötelező — az IPAM automatikusan származtatja belőle a nyilvántartási bejegyzést',
      nodeAddressing: 'Csomópont-címzés',
      nodeAddressingNone: 'Nincs — csomópontonkénti cím nélkül',
      nodeAddressingPool: 'Pool — egy rögzített cím minden kiszolgált csomóponthoz',
      nodeAddressingHint: 'Pool esetén a fabric-származtatás minden kiszolgált csomópontnak címet oszt ki a TVirt számára fenntartott tartományokból (kiosztás után rögzített).',
      backing: 'Backing',
      gateway: 'Gateway',
      ranges: 'Fenntartott címtartományok',
      dns: 'DNS-szerverek (vesszővel elválasztva)',
      dnsShort: 'DNS',
      singleSourceHint: 'Az itt deklarált gateway, DNS és útvonalak az egyetlen forrás — a szerverek NIC-jei, az Appok és a hálózati szolgáltatások innen merítenek',
      routesTitle: 'Statikus útvonalak',
      routeDestination: 'Cél (CIDR)',
      routeVia: 'Via (next hop)',
      portUsed: 'Használatban',
      vlanMappings: 'VLAN-leképezések',
      vlanTag: 'VLAN-tag',
      vlanNetwork: 'Logikai hálózat',
      nameTaken: 'A név már foglalt a fabricben',
      addNetwork: 'Hálózat hozzáadása',
      editNetwork: 'Hálózat szerkesztése',
      deleteNetwork: 'Hálózat eltávolítása',
      deleteNetworkConfirm: 'Eltávolítod a(z) {name} logikai hálózatot a fabricből? A származtatott IPAM-alhálózata vele hal (elutasítva, amíg szolgáltatás vagy App használja). A rá mutató port- és LAGG-hozzárendelések törlődnek.',
      switchName: 'Switch',
      portName: 'Port',
      positionHint: 'Fizikai pozíció (opcionális) — ugyanaz a szókincs, mint a szerverelhelyezésnél; csak deklaratív',
      addSwitch: 'Switch hozzáadása',
      editSwitch: 'Switch szerkesztése',
      deleteSwitch: 'Switch eltávolítása',
      deleteSwitchConfirm: 'Eltávolítod a(z) {name} switchet az összes portjával? A LAGG-ok ennek megfelelően összehúzódnak (és két port alatt meghalnak).',
      addPort: 'Port hozzáadása',
      editPort: 'Port szerkesztése',
      deletePort: 'Port eltávolítása',
      deletePortConfirm: 'Eltávolítod a(z) {name} portot?',
      untagged: 'Untagged',
      tagged: 'Tagged (tag:hálózat)',
      taggedShort: 'Tagged',
      portCabling: 'Kábelezés',
      portState: 'Állapot',
      stateUnused: 'nem használt',
      stateMapped: 'leképezett',
      laggPortGuard: 'Egy LAGG tagportja a LAGG oldaláról módosítható',
      laggsTitle: 'LAGG',
      laggsHint: 'Egy LAGG 2+ port LACP-ben, és átívelhet a switcheken (MLAG, transzparens); csak nem használt portok léphetnek be, a LAGG a leképezési felület, az eltávolított port újra nem használt lesz.',
      addLagg: 'LAGG hozzáadása',
      editLagg: 'LAGG szerkesztése',
      deleteLagg: 'LAGG eltávolítása',
      deleteLaggConfirm: 'Eltávolítod a(z) {name} LAGG-ot? A tagportjai újra nem használtak lesznek.',
      lacpRate: 'LACP-ráta',
      laggPorts: 'Tagportok (2+)',
      laggPortsHint: 'Csak nem használt portok léphetnek be — előbb szabadíts fel egy leképezett portot',
      noNetworks: 'Nincs deklarált logikai hálózat.',
      noSwitches: 'Nincs deklarált switch.',
      noLaggs: 'Nincs deklarált LAGG.',
      staleConflict: 'Egy másik operátor módosította ezt a fabricet, miközben szerkesztetted: a mentés elutasításra került, hogy ne törlődjön a munkája. A módosításaid még itt vannak, érintetlenül. A frissített fabric már újratöltődött: erősítsd meg újra, hogy rá alkalmazd őket, vagy vond vissza és nézd meg, mi változott.'
    },
    ipam: {
      title: 'IPAM',
      derivedHint: 'Csak származtatott: minden alhálózat egy logikai fabric-hálózatból vagy egy overlayből születik — a forrásánál módosítható. A kiosztott címek megmutatják, KI birtokolja őket; a TVirt számára fenntartott címtartományok az automatikus kiosztás címkészletei.',
      search: 'Keresés név, CIDR vagy cím szerint',
      empty: 'Nincs hálózat — deklarálj egy logikai fabric-hálózatot vagy egy overlay-alhálózatot: az IPAM belőlük származik automatikusan.',
      reserved: 'A TVirt számára fenntartott címtartományok',
      address: 'Cím',
      origin: 'Eredet',
      origin_declared: 'deklarált',
      origin_observed: 'megfigyelt',
      holder: 'Birtokosa',
      noAddresses: 'Ebben az alhálózatban nincs ismert cím.',
      sourceFabric: 'Fabric',
      sourceOverlay: 'Overlay',
      editAtSource: 'Módosítás a forrásnál'
    },

    // Rete > Firewall (#168): il vocabolario dei gruppi + la terna per-NIC.
    firewall: {
      title: 'Tűzfalcsoportok',
      createTitle: 'Új tűzfalcsoport',
      editTitle: 'Tűzfalcsoport szerkesztése',
      empty: 'Még nincs tűzfalcsoport — hozz létre egyet: újrafelhasználható szabályszókincs, amelyre a vendég NIC-ek név szerint hivatkoznak.',
      nameHint: 'Betűk, számjegyek és belső . - _; egyedi a saját scope-ján belül (a máshol lévő azonos nevűeket a /scope/név különbözteti meg)',
      description: 'Leírás',
      descriptionHint: 'Egyetlen sornyi szándék; mindenütt megjelenik, ahol a csoport kiválasztható',
      enforced: 'Kikényszerítve a scope-on',
      enforcedHint: 'Kikapcsolva: tiszta szókincs — a szabályok csak a csoportra hivatkozó NIC-eket kötik. Bekapcsolva: a szabályok a csoport scope-ja alatt minden olyan vendég NIC-et kötnek, amelynek tűzfala be van kapcsolva — hivatkozással vagy anélkül.',
      enforcedChip: 'Kikényszerítve',
      enforcedChipHint: 'A szabályok a csoport scope-ja alatt minden olyan vendég NIC-et kötnek, amelynek tűzfala be van kapcsolva — hivatkozással vagy anélkül',
      enforceWarning: 'A kikényszerítés bekapcsolásával a szabályok a következő összehangoláskor {scope} alatt MINDEN olyan vendég NIC-et kötnek, amelynek tűzfala be van kapcsolva, explicit hivatkozás nélkül is — és egy aktív chainen belül egy ős drop-ja végleges: az alatta lévő szintek nem nyitják újra.',
      unenforceInfo: 'A kikényszerítés kikapcsolásával a szabályok csak azokon a NIC-eken maradnak, amelyek explicit módon hivatkoznak a csoportra.',
      rules: 'Szabályok',
      tabOverview: 'Áttekintés',
      tabRules: 'Szabályok',
      orderHint: 'A sorok sorrendje MAGA a kiértékelési sorrend a csoporton belül: az első illeszkedő szabály nyer.',
      statefulHint: 'A stateful implicit: az engedélyezett forgalomra érkező válaszok maguktól átmennek (established/related elfogadva, invalid eldobva — a motor injektálja őket, kézzel nem írandók).',
      noRules: 'Nincs szabály — épülő szókincs: hivatkozni rá megengedett, és nem eredményez semmit.',
      addRule: 'Szabály hozzáadása',
      direction: 'Irány',
      directionIn: 'Bejövő',
      directionOut: 'Kimenő',
      action: 'Művelet',
      action_accept: 'Elfogad',
      action_drop: 'Eldob',
      action_reject: 'Elutasít',
      protocol: 'Protokoll',
      protocolAny: 'Bármely',
      ports: 'Portok',
      source: 'Forrás',
      dest: 'Cél',
      comment: 'Megjegyzés',
      addressHint: 'IPv4 CIDR vagy <fabric>/<logikai hálózat>; üresen = bármely',
      moveUp: 'Mozgatás felfelé',
      moveDown: 'Mozgatás lefelé',
      nicFirewall: 'Tűzfal',
      nicAntiSpoof: 'Anti-spoofing',
      nicGroups: 'Tűzfalcsoportok',
      nicGroupsPlaceholder: 'Válassz csoportot…',
      nicGroupsHint: 'A látható csoportok, beleértve a felsőbb scope-okéit is (lefelé használhatók, mint a címkék)',
      nicGroupCount: { one: '{n} tűzfalcsoport', other: '{n} tűzfalcsoport' },
      nicOff: 'Tűzfal kikapcsolva',
      pendingRestartHint: 'A tűzfal-módosítások a mentett/alkalmazott modellt követik: a következő power cycle-re várnak (PendingRestart). A felsőbb scope-ok által kikényszerített csoportok akkor érvényesülnek, amikor a NIC tűzfala be van kapcsolva.',
      appConvergeHint: 'A tűzfal-módosítások a konténer következő összehangolásakor lépnek életbe. A felsőbb scope-ok által kikényszerített csoportok akkor érvényesülnek, amikor a tűzfal be van kapcsolva.',
      enforcedAncestors: 'Felsőbb scope-ok által kikényszerítve',
      enforcedAncestorsHint: 'Ez a csoport a scope-ja alatti minden olyan NIC-re érvényes, amelynek tűzfala BE van kapcsolva — a kapcsoló a NIC főkapcsolója (kikapcsolva = egyáltalán nincs chain, az ősöket is beleértve); egy aktív chainen belül az ős tekintélye végleges: a drop-ja lentebb nem nyílik újra.'
    }
  }
}
